import { render, staticRenderFns } from "./WelcomeHeaderRoom.vue?vue&type=template&id=cb7c06c6&"
import script from "./WelcomeHeaderRoom.vue?vue&type=script&lang=js&"
export * from "./WelcomeHeaderRoom.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeHeaderRoom.vue?vue&type=style&index=0&id=cb7c06c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
